module.exports = __webpack_public_path__ + "static/media/accessory14.2d5af391.webp";